import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TopNavbarComponent } from '../../components/top-navbar/top-navbar.component';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DateTimeFlightPickerComponent } from '../../../datetimeflight-picker/datetimeflight-picker.component';
import { ParkingAndTransferPickerModalComponent } from '../../../parking-and-transfer-picker-modal/parking-and-transfer-picker-modal.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormControl } from '@angular/forms';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteParamService } from './../../../services/route-param.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-parking-and-transfer-booking',
  imports: [TopNavbarComponent, TextInputDataComponent, ParkingAndTransferPickerModalComponent, CommonModule, TranslocoModule,
    DateTimeFlightPickerComponent],
  templateUrl: './parking-and-transfer-booking.component.html',
  styleUrl: './parking-and-transfer-booking.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ParkingAndTransferBookingComponent {

  site: string = '';

  arrivalFlight: any;
  departureFlight: any;

  departureFlightDate: any;
  hotelArrivalDatetime: any;
  hotelDepartureDatetime: any;
  parkingArrivalTime: any;

  arrivalHotel: any;
  departureHotel: any;

  isArrivalHotel: any;
  isDepartureHotel: any;

  parkingStartTime: any;
  parkingEndTime: any;

  selectType: string = '';
  searchData: any;

  routerState: any;

  discountCodeControl: FormControl = new FormControl('');
  flightTimeWarning: boolean = false;
  isLoggedIn: boolean = false;
  parkingOperators: any[] = [];
  orgId: any = '';
  showToggle: any = false;
  _organization: string = '';
  departureDatetime: any;
  departureDatetimeForTransfer: any;
  arrivalDate: any;
  parkingEndDatetime: any;
  departurePassengers: any;
  arrivalTerminal: any;
  departureTerminal: any;
  departureRoute: any;
  arrivalRoute: any;
  isArrivalByFlight: any;
  diffInDays: boolean = false;
  parkingStartDate: any;

  constructor(
    private bookingConfigService: BookingConfigService,
    private formService: FormService,
    private router: Router,
    private route: ActivatedRoute,
    private routeParamService: RouteParamService,
    private snackBar: MatSnackBar,
    private translocoService: TranslocoService
  ) {
    const urlSegments = this.router.url.split('/');
    if (urlSegments[2] === 'aiden-parkandfly') {
      this.bookingConfigService.setOrganization('aiden');
    } else {
      this.bookingConfigService.setOrganization('quality');
    }
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.formService.initForm(this.site);

    const routerState = this.router.getCurrentNavigation();

    if (routerState?.extras) {
      const stateData = routerState?.extras?.state ?? null;

      if (stateData) {
        this.searchData = stateData.searchData ? stateData.searchData : stateData;

        if (stateData.selectedParking || this.searchData?.selectedParking) {
          this.formService.selectedParking = stateData.selectedParking || this.searchData?.selectedParking;
        }

        const getVal = (field: any) => {
          if (field && typeof field === 'object' && 'value' in field) {
            return field.value;
          }
          return field;
        };

        this.isDepartureHotel = getVal(this.searchData?.isDepartureHotel);
        this.isArrivalHotel = getVal(this.searchData?.isArrivalHotel);
        this.isArrivalByFlight = getVal(this.searchData?.isArrivalByFlight);
        this.arrivalDate = getVal(this.searchData?.arrivalDate);
        this.arrivalFlight = getVal(this.searchData?.arrivalFlight);
        this.departureFlight = getVal(this.searchData?.departureFlight);
        this.departureFlightDate = getVal(this.searchData?.departureFlightDate);
        this.departureDatetime = getVal(this.searchData?.departureDatetime);
        this.departureDatetimeForTransfer = getVal(this.searchData?.departureDatetimeForTransfer);
        this.parkingEndDatetime = getVal(this.searchData?.parkingEndDatetime);
        this.departureTerminal = getVal(this.searchData?.departureTerminal);
        this.arrivalTerminal = getVal(this.searchData?.arrivalTerminal);
        this.arrivalRoute = getVal(this.searchData?.arrivalRoute);
        this.departureRoute = getVal(this.searchData?.departureRoute);
        this.departurePassengers = getVal(this.searchData?.departurePassengers);
        this.parkingStartDate = getVal(this.searchData?.parkingStartDate);
      }
    }

  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const discountParam = params.get('discount_code') || params.get('discountCode');
      if (discountParam) {
        if (discountParam.toUpperCase() === 'NONE' || discountParam === 'null') {
          this.discountCodeControl.setValue('');
        } else {
          this.discountCodeControl.setValue(discountParam);
        }
      }
    });

    this.route.paramMap.subscribe(params => {
      this._organization = params.get('organization') || "";
      this.routeParamService.setOrg(this._organization);
      this.bookingConfigService.setOrganizationFromUrl();
      this.site = this.bookingConfigService.getConfig().site;
      this.selectType = this.bookingConfigService.getConfig().searchSelect;
      this.formService.initForm(this.site);
    });

    if (this.site == 'quality' || this.site == 'aiden') {
      const search = this.formService.getForm().get('search');
      const flights = this.formService.getForm().get('flights');
      const hotels = this.formService.getForm().get('hotels');
      const pickups = this.formService.getForm().get('pickup');
      const terminals = this.formService.getForm().get('terminal');

      // if (!this.searchData) {
      // Initialize values from form
      this.isArrivalHotel = search.controls.isArrivalHotel.value;
      this.isDepartureHotel = search.controls.isDepartureHotel.value;
      this.arrivalFlight = flights.controls.arrivalFlight.value;
      this.departureFlight = flights.controls.departureFlight.value;
      this.departureFlightDate = hotels.controls.departureFlightDate.value;
      this.departureDatetime = hotels.controls.departureDatetime.value;
      this.departureDatetimeForTransfer = hotels.controls.departureDatetimeForTransfer.value;
      this.arrivalDate = hotels.controls.arrivalDate.value;
      this.parkingEndDatetime = hotels.controls.parkingEndDatetime.value;
      this.departurePassengers = pickups.controls.departurePassengers.value;
      this.departureRoute = pickups.controls.departureRoute.value;
      this.arrivalRoute = pickups.controls.arrivalRoute.value;
      this.arrivalTerminal = terminals.controls.arrivalTerminal.value;
      this.departureTerminal = terminals.controls.departureTerminal.value;
      this.isArrivalByFlight = search.controls.isArrivalByFlight.value;
      this.parkingStartDate = this.isDepartureHotel ? '' : hotels.controls.parkingStartDate.value;
      // }

      flights.controls.arrivalFlight.valueChanges.subscribe((value: any) => {
        this.arrivalFlight = value;
      });
      flights.controls.departureFlight.valueChanges.subscribe((value: any) => {
        this.departureFlight = value;
      });

      hotels.controls.departureFlightDate.valueChanges.subscribe((value: any) => {
        this.departureFlightDate = value;
      });
      hotels.controls.departureDatetime.valueChanges.subscribe((value: any) => {
        this.departureDatetime = value;
      });
      hotels.controls.departureDatetimeForTransfer.valueChanges.subscribe((value: any) => {
        this.departureDatetimeForTransfer = value;
      });
      hotels.controls.arrivalDate.valueChanges.subscribe((value: any) => {
        this.arrivalDate = value;
      });
      hotels.controls.parkingEndDatetime.valueChanges.subscribe((value: any) => {
        this.parkingEndDatetime = value;
      });
      hotels.controls.parkingStartDate.valueChanges.subscribe((value: any) => {
        this.parkingStartDate = value;
      });

      pickups.controls.departurePassengers.valueChanges.subscribe((value: any) => {
        this.departurePassengers = value;
      });
      pickups.controls.departureRoute.valueChanges.subscribe((value: any) => {
        this.departureRoute = value;
      });
      pickups.controls.arrivalRoute.valueChanges.subscribe((value: any) => {
        this.arrivalRoute = value;
      });

      terminals.controls.arrivalTerminal.valueChanges.subscribe((value: any) => {
        this.arrivalTerminal = value;
      });
      terminals.controls.departureTerminal.valueChanges.subscribe((value: any) => {
        this.departureTerminal = value;
      });

      search.controls.isArrivalHotel.valueChanges.subscribe((value: any) => {
        this.isArrivalHotel = value;
      });
      search.controls.isDepartureHotel.valueChanges.subscribe((value: any) => {
        this.isDepartureHotel = value;
      });
      search.controls.isArrivalByFlight.valueChanges.subscribe((value: any) => {
        this.isArrivalByFlight = value;
      });

    }
  }

  private checkParkingDuration(): boolean {
    let parkingStartDateTime: string;
    let parkingEndDateTime: string;

    if (this.isDepartureHotel) {
      parkingStartDateTime = this.departureDatetime;
    } else {
      if (this.departureRoute?.startDate) {
        const date = this.departureRoute.startDate.toDate();
        date.setHours(date.getHours() - 1);
        parkingStartDateTime = this.formatDateTime(date);
      } else {
        return false;
      }
    }

    if (this.isArrivalHotel) {
      parkingEndDateTime = this.parkingEndDatetime;
    } else {
      if (this.arrivalRoute?.startDate) {
        const date = this.arrivalRoute.startDate.toDate();
        date.setHours(date.getHours() + 1);
        parkingEndDateTime = this.formatDateTime(date);
      } else {
        return false;
      }
    }

    if (parkingStartDateTime && parkingEndDateTime) {
      const startDate = new Date(parkingStartDateTime);
      const endDate = new Date(parkingEndDateTime);
      const diffInMs = endDate.getTime() - startDate.getTime();
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      return diffInDays > 28;
    }

    return false;
  }

  get isParkingDurationExceeded(): boolean {
    if (this.site?.toLowerCase() !== 'aiden' && this.isArrivalHotel == false && this.isDepartureHotel == false) {
      return false;
    }
    return this.checkParkingDuration();
  }

  get isContinueButtonEnabled(): boolean {

    // Primary check: At least one of isArrivalHotel or isDepartureHotel must be true (except for Aiden)
    if (this.site?.toLowerCase() !== 'aiden' && this.isArrivalHotel == false && this.isDepartureHotel == false) {
      return false;
    }

    let isDepartureComplete = false;
    let isArrivalComplete = false;

    const option1 = this.departureFlightDate && this.departurePassengers && this.departureFlight && this.departureRoute;
    const option2 = this.departureDatetime && this.departurePassengers && this.departureDatetimeForTransfer && this.departureRoute && this.departureTerminal;
    isDepartureComplete = option1 || option2;

    let case1 = this.arrivalDate && this.departurePassengers && this.arrivalFlight && this.arrivalRoute;
    let case2 = this.arrivalDate && this.departurePassengers && this.arrivalTerminal && this.arrivalRoute;
    if (this.isArrivalHotel) {
      case1 = case1 && this.parkingEndDatetime;
      case2 = case2 && this.parkingEndDatetime;
    }
    isArrivalComplete = case1 || case2;

    if (!(isDepartureComplete && isArrivalComplete)) {
      return false;
    }

    return !this.checkParkingDuration();
  }

  goToBookingForm() {
    let parkingStartDateTime: string;
    let parkingEndDateTime: string;

    // Determine parking start date
    if (this.isDepartureHotel) {
      // Use departure date time for transfer
      parkingStartDateTime = this.departureDatetime;
    } else {
      // Use departure pickup time from route
      if (this.departureRoute?.startDate) {
        const date = this.departureRoute.startDate.toDate();
        date.setHours(date.getHours() - 1);
        parkingStartDateTime = this.formatDateTime(date);
      } else {
        parkingStartDateTime = '';
      }

    }

    // Determine parking end date
    if (this.isArrivalHotel) {
      // Use parking end datetime
      parkingEndDateTime = this.parkingEndDatetime;
    } else {
      // Use arrival pickup time from route
      if (this.arrivalRoute?.startDate) {
        const date = this.arrivalRoute.startDate.toDate();
        date.setHours(date.getHours() + 1);
        parkingEndDateTime = this.formatDateTime(date);
      } else {
        parkingEndDateTime = '';
      }
    }

    // Convert Moment dates to strings for serialization
    const serializeDepartureRoute = this.departureRoute ? {
      ...this.departureRoute,
      startDate: this.departureRoute.startDate ? (this.departureRoute.startDate.toISOString ? this.departureRoute.startDate.toISOString() : this.departureRoute.startDate.format('YYYY-MM-DDTHH:mm:ss')) : null,
      endDate: this.departureRoute.endDate ? (this.departureRoute.endDate.toISOString ? this.departureRoute.endDate.toISOString() : this.departureRoute.endDate.format('YYYY-MM-DDTHH:mm:ss')) : null
    } : null;

    const serializeArrivalRoute = this.arrivalRoute ? {
      ...this.arrivalRoute,
      startDate: this.arrivalRoute.startDate ? (this.arrivalRoute.startDate.toISOString ? this.arrivalRoute.startDate.toISOString() : this.arrivalRoute.startDate.format('YYYY-MM-DDTHH:mm:ss')) : null,
      endDate: this.arrivalRoute.endDate ? (this.arrivalRoute.endDate.toISOString ? this.arrivalRoute.endDate.toISOString() : this.arrivalRoute.endDate.format('YYYY-MM-DDTHH:mm:ss')) : null
    } : null;

    const getValString = (val: any) => {
      if (!val) return null;
      if (val instanceof Date) return this.formatDateTime(val);
      if (typeof val === 'string') return val;
      return val;
    };

    let searchData = {
      isArrivalHotel: this.isArrivalHotel,
      isDepartureHotel: this.isDepartureHotel,
      isArrivalByFlight: this.isArrivalByFlight,
      arrivalDate: getValString(this.arrivalDate),
      arrivalFlight: this.arrivalFlight,
      departureFlight: this.departureFlight,
      parkingEndDatetime: getValString(this.parkingEndDatetime),
      departureFlightDate: getValString(this.departureFlightDate),
      departureDatetime: getValString(this.departureDatetime),
      departureDatetimeForTransfer: getValString(this.departureDatetimeForTransfer),
      departurePassengers: this.departurePassengers,
      departureRoute: serializeDepartureRoute,
      arrivalRoute: serializeArrivalRoute,
      arrivalTerminal: this.arrivalTerminal,
      departureTerminal: this.departureTerminal,
      parkingStartDate: this.isDepartureHotel ? '' : getValString(this.parkingStartDate),
      selectedParking: this.searchData?.selectedParking || this.formService.selectedParking || history.state?.selectedParking
    }

    let queryParams: any = {
      parking_start: parkingStartDateTime,
      parking_end: parkingEndDateTime
    };

    if (this.discountCodeControl.value && this.discountCodeControl.value.trim().toUpperCase() !== 'NONE') {
      queryParams['discount_code'] = this.discountCodeControl.value;
    }

    this.router.navigate(['parkifly/parking-and-transfer', this.site, 'booking', queryParams],
      {
        state: {
          searchData,
          org: this._organization || this.site,
          selectedParking: this.searchData?.selectedParking || this.formService.selectedParking || history.state?.selectedParking
        }
      }
    );
  }

  private formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

}
